import { cleanName, orNull } from '../../../common/utils/text';

// Builds the semen create/update payload (api-reference/admin-semen.md, decisión 0021).
// Padre nested-or-ref — EXACTAMENTE uno:
//   · 'existing' → sire_animal_id (toro ya registrado)
//   · 'new'      → sire_animal { name, race_id, register?, is_external:true } (toro de
//                  referencia creado anidado; el backend fuerza sex:male + baptized:true).
export function buildSemenPayload(form) {
    const sire = form.sireMode === 'new'
        ? {
            sire_animal: {
                name: cleanName(form.newName),
                race_id: form.newRace ? Number(form.newRace) : undefined,
                ...(orNull(form.newRegister) ? { register: orNull(form.newRegister) } : {}),
                is_external: true,
            },
        }
        : { sire_animal_id: form.sireAnimal ? Number(form.sireAnimal.id) : undefined };

    return {
        code:     cleanName(form.code),
        name:     orNull(form.name),
        race_id:  form.race_id ? Number(form.race_id) : null,
        origin:   form.origin || null,
        supplier: orNull(form.supplier),
        ...sire,
    };
}
